import { Box, CollapsibleCard, Flex } from '@volue/wave-react';
import React from 'react';

export type ErrorWithDetails = {
  mainMessage: string;
  details: string;
};

export const CollapsibleError: React.FunctionComponent<{
  error: ErrorWithDetails;
}> = ({ error }) => {
  return (
    <CollapsibleCard>
      <CollapsibleCard.Header>{error.mainMessage}</CollapsibleCard.Header>
      <CollapsibleCard.Body>
        <Flex flow="column">
          <Box>{error.details}</Box>
        </Flex>
      </CollapsibleCard.Body>
    </CollapsibleCard>
  );
};
